import { UserManagement } from './UserManagement'
import { FortnoxConnection } from './FortnoxConnection'

interface SettingsProps {
  fortnoxError?: string | null
  onClearFortnoxError?: () => void
  fortnoxSuccess?: boolean
  onClearFortnoxSuccess?: () => void
}

export function Settings({ fortnoxError, onClearFortnoxError, fortnoxSuccess, onClearFortnoxSuccess }: SettingsProps) {
  return (
    <div>
      <FortnoxConnection 
        fortnoxError={fortnoxError} 
        onClearFortnoxError={onClearFortnoxError}
        fortnoxSuccess={fortnoxSuccess}
        onClearFortnoxSuccess={onClearFortnoxSuccess}
      />
      <div style={{ marginTop: '32px' }}>
        <UserManagement />
      </div>
    </div>
  )
}